export default __webpack_public_path__ + "static/media/fileupload.086ad6df.svg";